import { AgoraProxyMode } from 'domain/event';

import type { ClientRole, NetworkQuality } from 'agora-rtc-react';
import type { MediaTrackErrorKey } from 'devices/types';
import type { MediaTrackState } from 'domain/Broadcast';

type MediaTrack = {
  currentDeviceId: string | null;
  error: MediaTrackErrorKey | null;
  /** Currently only used for videoTrack — audio does not have retry/recovery logic. */
  isCircuitBreakerTripped: boolean;
  isPublished: boolean;
  state: MediaTrackState;
};

export type AgoraState = {
  connectionTestState: 'idle' | 'in progress' | 'completed' | 'failed';
  isJoined: boolean;
  audioTrack: MediaTrack;
  videoTrack: MediaTrack;
  networkQuality: NetworkQuality[];
  role: ClientRole | undefined;
  supportedCloudProxyOptions: AgoraProxyMode[];
  remoteNetworkQuality: Record<string, NetworkQuality | undefined>;
};

export enum NetworkQualityState {
  Unknown,
  Excellent,
  Good,
  SlightlyImpared,
  Poor,
  BarelyUsable,
  Disconnected,
}

export enum NetworkErrorKey {
  UnstableConnection = 'unstableConnection',
  UnstableDownlinkConnection = 'unstableDownlinkConnection',
  UnstableUplinkConnection = 'unstableUplinkConnection',
}
